import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { accountEndpoints } from '@pff-consumer/api-sdk'
import type { CancelSubscriptionResponse, SubscriptionInfo } from '@pff-consumer/schema'
import { envConfig } from '@pff-consumer/utils'

const { CONSUMER_API_KEY } = envConfig

const getAuthTokenFromState = (state: unknown): string | undefined => {
  // @ts-ignore
  return state?.account?.token
}

export const subscriptionApi = createApi({
  reducerPath: 'subscriptionApi',
  baseQuery: fetchBaseQuery({
    baseUrl: '/',
    prepareHeaders: (headers, { getState }) => {
      // We need to get the auth/jwt token from the store and add to the headers for every api call
      const authToken = getAuthTokenFromState(getState())
      if (authToken) {
        headers.append('Authorization', authToken)
      }
      headers.append('Api-Key', CONSUMER_API_KEY)

      return headers
    },
  }),

  endpoints: (builder) => ({
    cancelSubscription: builder.mutation<CancelSubscriptionResponse, void>({
      query: () => {
        return {
          url: accountEndpoints.cancelSubscription().url,
          method: 'post',
          headers: {
            'Content-type': 'application/json',
          },
        }
      },
    }),
    getSubscriptionDetails: builder.query<SubscriptionInfo, void>({
      query: () => {
        return {
          url: accountEndpoints.getSubscriptionDetails().url,
          method: 'get',
          headers: {
            'Content-type': 'application/json',
          },
        }
      },
    }),
  }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useCancelSubscriptionMutation, useGetSubscriptionDetailsQuery } = subscriptionApi

// Export getters to be used when rendering components on the server
export const { cancelSubscription, getSubscriptionDetails } = subscriptionApi.endpoints
